<template>
	<div class="body"> 
		<a name="map"></a>
		<div class="head">
			<div class="menu" :class="menuClass">
				<a href="#map"><img src="../assets/img/menu1.png" alt="" v-show="menu !== 1" @click="menu = 1"></a>
				<img src="../assets/img/menu1_hover.png" class="hover" v-show="menu === 1" alt="">
				<a href="#world"><img src="../assets/img/menu2.png" alt="" v-show="menu !== 2" @click="menu = 2"></a>
				<img src="../assets/img/menu2_hover.png" class="hover" v-show="menu === 2" alt="">
				<a href="#data"><img src="../assets/img/menu3.png" alt="" v-show="menu !== 3" @click="menu = 3"></a>
				<img src="../assets/img/menu3_hover.png" class="hover" v-show="menu === 3" alt="">
				<a href="#news"><img src="../assets/img/menu4.png" alt="" v-show="menu !== 4" @click="menu = 4"></a>
				<img src="../assets/img/menu4_hover.png" class="hover" v-show="menu === 4" alt="">
			</div>
		</div>
		<div class="map">
			<div class="map-content">
				<div class="map-title">{{ news.news_title }}</div>
				<div class="map-btn">
					<div class="map-prov">
						<img src="../assets/img/icon_loction.png" alt="">
						<i>{{ news.name }}</i>
					</div>
					<a :href="news | link"><img src="../assets/img/skip.png" class="map-skip" alt="" srcset=""></a>
				</div>
			</div>
			<div id="map"></div>
		</div>
		<a name="world"></a>
		<div class="title" id="world-top">两会热词</div>
		<div class="world" id="tagbox">
			<a href="javascript:void()" v-for="item in tags" :key="item.name" :style="'font-size:' + item.size + 'em;color:' + item.color + ';'" :size="item.size">{{ item.text }}</a>
		</div>
		<a name="data"></a>
		<div class="title" id="data-top">数说两会</div>
		<div class="data">
			<div id="gdp"></div>
			<div id="zpsr"></div>
			<!-- <div id="pie"></div> -->
			<div class="data-list">
				<div class="data-item">
					<div class="data-item-name"><span id="data-gdp">99.1</span>万亿元</div>
					<p>去年，我国经济运行总体平稳，国内生产总值99.1万亿元，增长6.1%。</p>
				</div>
				<div class="data-item">
					<div class="data-item-name"><span id="data-jy">900</span>万人</div>
					<p>今年要优先稳就业保民生，坚决打赢脱贫攻坚战，努力实现全面建成小康社会目标任务；城镇新增就业900万人以上，城镇调查失业率6%左右。</p>
				</div>
				<div class="data-item">
					<div class="data-item-name"><span>1</span>万亿元</div>
					<p>今年赤字率拟按3.6％以上安排，财政赤字规模比去年增加1万亿元，同时发行1万亿元抗疫特别国债。</p>
				</div>
				<div class="data-item">
					<div class="data-item-name"><span id="data-jf">2.5</span>万亿元</div>
					<p>加大减税降费力度，预计全年为企业新增减负超过2.5万亿元。</p>
				</div>
				<div class="data-item">
					<div class="data-item-name"><span id="data-zj">3.75</span>万亿元</div>
					<p>拟安排地方政府专项债券3.75万亿元，中央预算内投资安排6000亿元。</p>
				</div>
				<div class="data-item">
					<div class="data-item-name"><span id="data-dk">40%</span></div>
					<p>大型商业银行普惠型小微企业贷款增速要高于40%。</p>
				</div>
				<div class="data-item">
					<div class="data-item-name"><span id="data-nt">8000</span>万亩</div>
					<p>新建高标准农田8000万亩。</p>
				</div>
			</div>
		</div>
		<a name="news"></a>
		<div class="title" id="news-top">两会专题</div>
		<div class="news">
			<a :href="item | link" class="news-item" v-for="item in list" :key="item.news_id">
				<img :src="item.img_url" alt="">
				<div class="news-title">
					<div class="news-name">{{ item.news_title }}</div>
					<div class="news-source">
						<span>{{ item.source }}</span>
					</div>
				</div>
			</a>
		</div>
	</div>
</template>

<script>

import CONFIG from '@/utils/config'
import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'

import { mapState, mapActions } from 'vuex'

let lasta = 1;  // 词云滚动系数
let lastb = 1;

let autoNews = '';

export default {
  name: 'home',
  data() {
		return {
			menu: 1,
			menuClass: '',
			provList: [],
			tags: [
				{
					text: '脱贫攻坚',
					color: '#dd2b23',
					size: 1.3
				},
				{
					text: '民法典',
					color: '',
					size: 1.25
				},
				{
					text: '个人信息保护法',
					color: '#dd2b23',
					size: 1.2
				},
				{
					text: '禁止非法野生动物交易',
					color: '',
					size: 1.15
				},
				{
					text: '社会主义市场经济体制',
					color: '',
					size: 1.1
				},
				{
					text: '疫情防控常态化',
					color: '#dd2b23',
					size: 1.05
				},
				{
					text: '政府工作报告',
					color: '',
					size: 1
				},
				{
					text: '就业',
					color: '#ff5500',
					size: 1
				},
				{
					text: '突发公共卫生事件应急条例',
					color: '',
					size: 1
				},
				{
					text: '复工复产',
					color: '',
					size: 1
				},
				{
					text: '成渝地区经济圈',
					color: '#ff5500',
					size: 1
				},
				{
					text: '垃圾分类',
					color: '',
					size: 1
				},
				{
					text: '现代产业体系',
					color: '',
					size: 1
				},
				{
					text: '改革开放创新',
					color: '',
					size: 1
				},
				{
					text: '城乡融合发展',
					color: '',
					size: 1
				},
				{
					text: '生态文明发展',
					color: '',
					size: 2
				},
				{
					text: '公共服务',
					color: '#dd2b23',
					size: 1
				},
				{
					text: '社会治理能力',
					color: '',
					size: 1
				},
				{
					text: '政府自身建设',
					color: '',
					size: 0.95
				},
				{
					text: '人工智能',
					color: '',
					size: 0.9
				},
				{
					text: '5G技术',
					color: '#1890ff',
					size: 0.85
				},
				{
					text: '新基建',
					color: '#1890ff',
					size: 0.8
				},
			],
			news: {
				name: '四川',
				title: ''
			},
			list: []
		}
	},
	computed: {
    ...mapState(['shareData'])
	},
	filters: {
		link(info) {
			if (COVERAPP.Attribute.isApp()) {
				return 'cover://cn.thecover.www/news?id=' + info.news_id + '&flag=' + info.flag;
			}
			return 'https://m.thecover.cn/news_details.html?id=' + info.news_id;
		}
	},
	mounted() {
		const _this = this;
		this.share()
		document.querySelector('.loading-wrap').style.display = 'none'	
		this.setPageLoadingAsync(false)
		this.getList()
		this.getYian()
		this.map()
		this.world()
		this.gdp()
		setTimeout(function() {
			_this.zpsr();
		}, 1000);
		this.anNumber();
		// this.pie()

		const menuTop = document.querySelector('.menu').offsetTop;

		document.body.onscroll = function() {
			const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
			const worldTop = document.querySelector('#world-top').offsetTop;
			const dataTop = document.querySelector('#data-top').offsetTop;
			const newsTop = document.querySelector('#news-top').offsetTop;

			const menuHeight = document.querySelector('.menu ').clientHeight;

			if (scrollTop > menuTop) {
				_this.menuClass = 'menu-top';
			} else {
				_this.menuClass = '';
			}

			if ((scrollTop - menuHeight) < worldTop) {
				_this.menu = 1;
			}

			if ((scrollTop + menuHeight) > worldTop) {
				_this.menu = 2;
			}

			if ((scrollTop + menuHeight) > dataTop) {
				_this.menu = 3;
			}

			if ((scrollTop + menuHeight) > newsTop) {
				_this.menu = 4;
			}


		}
	},
	methods: {
		...mapActions([
			'setPageLoadingAsync'
    ]),
		share() {
			COVER.share(this.shareData);
		},
		// 数字动画
		anNumber() {
			setInterval(function() {
				let gdp = 0;
				const gdpt = setInterval(function() {
					gdp += 5;
					if (gdp > 99.1) {
						gdp = 99.1;
						clearInterval(gdpt);
					}
					document.getElementById('data-gdp').innerText = gdp;
				}, 30);
			}, 4500);

			setInterval(function() {
				let gdp = 0;
				const gdpt = setInterval(function() {
					gdp += 55;
					if (gdp > 900) {
						gdp = 900;
						clearInterval(gdpt);
					}
					document.getElementById('data-jy').innerText = gdp;
				}, 30);
			}, 5500);

			setInterval(function() {
				let gdp = 0;
				const gdpt = setInterval(function() {
					gdp += 0.15;
					if (gdp > 2.5) {
						gdp = 2.5;
						clearInterval(gdpt);
					}
					document.getElementById('data-jf').innerText = gdp.toFixed(1);
				}, 30);
			}, 4800);

			setInterval(function() {
				let gdp = 0;
				const gdpt = setInterval(function() {
					gdp += 0.35;
					if (gdp > 3.75) {
						gdp = 3.75;
						clearInterval(gdpt);
					}
					document.getElementById('data-zj').innerText = gdp.toFixed(2);
				}, 30);
			}, 5600);

			setInterval(function() {
				let gdp = 0;
				const gdpt = setInterval(function() {
					gdp += 3;
					if (gdp > 40) {
						gdp = 40;
						clearInterval(gdpt);
					}
					document.getElementById('data-dk').innerText = gdp + '%';
				}, 30);
			}, 6600);

			setInterval(function() {
				let gdp = 0;
				const gdpt = setInterval(function() {
					gdp += 456;
					if (gdp > 8000) {
						gdp = 8000;
						clearInterval(gdpt);
					}
					document.getElementById('data-nt').innerText = gdp;
				}, 30);
			}, 4300);
		},
		map() {
			const _this = this;
			let name = '四川';
			this.autoNews();

			this.chianMap = echarts.init(document.getElementById('map'));
			this.option = {
				tooltip: {
					trigger: 'item',
					show: false,
					formatter: function(params) {
						return 'qeq';
					},
					textStyle: {
						fontSize: 12
					}
				},
				series: [{
					name: '中国',
					type: 'map',
					mapType: 'china',
					roam: false,//是否开启鼠标缩放和平移漫游
					data: [{
						name,
						selected: true
					}],
					top: "10%",//组件距离容器的距离
					zoom: 1.2,
					selectedMode : 'single',
					label: {
						normal: {
							show: true,//显示省份标签
							textStyle: { color: "#000000", fontSize: 6}//省份标签字体颜色
						},
						emphasis: {//对应的鼠标悬浮效果
							show: true,
							textStyle:{color:"#ffffff", fontSize: 8}
						}
					},
					itemStyle: {
						normal: {
							borderWidth: .5,//区域边框宽度
							borderColor: '#cc9d99',//区域边框颜色
							areaColor: '#ffdcd3',//区域颜色
						},
						emphasis: {
							borderWidth: 1.5,
							borderColor: '#ffffff',
							areaColor:"#dd2b23",
						}
					}
				}]
			};
			this.chianMap.setOption(this.option);
			
			this.chianMap.on('click', function(e) {
				clearInterval(autoNews);
				name = e.name;
				const provList = _this.provList;
				for (let i = 0; i < provList.length; i++) {
					if (provList[i].category_name.indexOf(name) > -1) {
						_this.news = provList[i].news[(Math.floor(Math.random() * provList[i].news.length))];
						_this.news.name = provList[i].category_name;
					}
				}

				_this.option.series[0].data[0].name = name;
				_this.chianMap.setOption(_this.option);

				setTimeout(function() {
					_this.autoNews();
				}, 5000);
			});
		},
		autoNews() {
			clearInterval(autoNews);
			const _this = this;
			autoNews = setInterval(function() {
				const provList = _this.provList;
				const num = Math.floor(Math.random() * provList.length);
				for (let i = 0; i < provList.length; i++) {
					if (i === num) {
						const name = provList[i].category_name;
						let provName = name.split('省')[0].split('市')[0];

						if (provName.indexOf('新疆') > -1) {
							provName = '新疆';
						}

						if (provName.indexOf('西藏') > -1) {
							provName = '西藏';
						}

						if (provName.indexOf('宁夏') > -1) {
							provName = '宁夏';
						}

						if (provName.indexOf('广西') > -1) {
							provName = '广西';
						}

						if (provName.indexOf('内蒙古') > -1) {
							provName = '内蒙古';
						}

						if (provName.indexOf('澳门') > -1) {
							provName = '澳门';
						}

						if (provName.indexOf('香港') > -1) {
							provName = '香港';
						}

						_this.news = provList[i].news[(Math.floor(Math.random() * provList[i].news.length))];
						_this.news.name = name;

						_this.option.series[0].data[0].name = provName;
						_this.chianMap.setOption(_this.option);
					}
				}
			}, 3000);
		},
		getList() {
			COVER.ajaxGet('/wap/getSubjectInfo', {
				data: JSON.stringify({
					subject_id: 4260
				})
			}).then(res => {
				if (res.status === 0) {
					const list = res.data.list;
					for (let i = 0; i < list.length; i++) {
						if (list[i].category_name.indexOf('四川') > -1) {
							let news = list[i].news[0];
							news.name = '四川省';
							this.news = news;
						}
					}
					this.provList = list;
				}
			});
		},
		getNews(name) {
			COVER.ajaxGet('/wap/getCategoryNews', {
				data: JSON.stringify({
					subject_id: 4104,
					category_id: mapNews[name],
					page: 1,
					page_size: 1
				})
			}).then(res => {
				if (res.status === 0) {
					const info = res.data;
					let news = info.news[0];
					news.name = name;
					this.news = news;
				}
			});
		},
		getYian() {
			COVER.ajaxGet('/wap/getSubject', {
				data: JSON.stringify({
					subject_id: 4207,
					channel_type: 13,
					page: 1,
					page_size: 10
				})
			}).then(res => {
				if (res.status === 0) {
					const info = res.data;
					const list = info.list || [];
					this.list = list;
				}
			});
		},
		onNews() {
			const news = this.news;
			const link = 'https://m.thecover.cn/news_details.html?id=' + news.news_id;
			if (COVERAPP.Attribute.isApp()) {
				link = 'cover://cn.thecover.www/news?id=' + news.news_id + '&flag=' + news.flag;
			}

			window.location.href = link;
		},
		world() {
			var radius = window.innerWidth / 2.5;
			var dtr = Math.PI / 180;
			var d= window.innerWidth;

			var mcList = [];
			var active = true;
			var distr = true;
			var tspeed = 5;
			var size = 250;

			var mouseX= -5;
			var mouseY= -5;

			var howElliptical=1;

			var aA=null;
			var oDiv=null;

			var sa = '';
			var ca = '';
			var sb = '';
			var cb = '';
			var sc = '';
			var cc = '';
			var per = '';

			var i = 0;
			var oTag=null;
			oDiv = document.getElementById('tagbox');
			
			aA = oDiv.getElementsByTagName('a');
			
			for (i=0;i<aA.length;i++) {
				oTag={};
				oTag.offsetWidth=aA[i].offsetWidth;
				oTag.offsetHeight=aA[i].offsetHeight;
				mcList.push(oTag);
			}
			sineCosine( 0,0,0 );
			positionAll();
			/* oDiv.onmouseover = function () {
				active = true;
			};
			
			oDiv.onmouseout = function () {
				active = false;
			};
			
			oDiv.onmousemove = function (ev) {
				var oEvent=window.event || ev;
				mouseX=oEvent.clientX-(oDiv.offsetLeft+oDiv.offsetWidth/2);
				mouseY=oEvent.clientY-(oDiv.offsetTop+oDiv.offsetHeight/2);
				mouseX /= 5;
				mouseY /= 5;
			};

			oDiv.ontouchover = function () {
				active = true;
			};
			
			oDiv.ontouchout = function () {
				active = false;
			};

			oDiv.ontouchmove = function() {
				var oEvent=window.event || ev;
				mouseX=oEvent.clientX-(oDiv.offsetLeft+oDiv.offsetWidth/2);
				mouseY=oEvent.clientY-(oDiv.offsetTop+oDiv.offsetHeight/2);
				mouseX /= 5;
				mouseY /= 5;
			} */
			
			setInterval(update, 30);

			function update() {
				var a;
				var b;
				
				if (active) {
					a = (-Math.min( Math.max( -mouseY, -size ), size ) / radius ) * tspeed;
					b = (Math.min( Math.max( -mouseX, -size ), size ) / radius ) * tspeed;
				} else {
					a = lasta * 0.98;
					b = lastb * 0.98;
				}
				
				lasta = a;
				lastb = b;
				
				if (Math.abs(a) <= 0.01 && Math.abs(b) <= 0.01) {
					return;
				}
				
				var c = 0;
				sineCosine(a,b,c);
				for(var j=0;j<mcList.length;j++) {
					var rx1=mcList[j].cx;
					var ry1=mcList[j].cy*ca+mcList[j].cz*(-sa);
					var rz1=mcList[j].cy*sa+mcList[j].cz*ca;
					
					var rx2=rx1*cb+rz1*sb;
					var ry2=ry1;
					var rz2=rx1*(-sb)+rz1*cb;
					
					var rx3=rx2*cc+ry2*(-sc);
					var ry3=rx2*sc+ry2*cc;
					var rz3=rz2;
					
					mcList[j].cx=rx3;
					mcList[j].cy=ry3;
					mcList[j].cz=rz3;
					
					per=d/(d+rz3);
					
					mcList[j].x=(howElliptical*rx3*per)-(howElliptical*2);
					mcList[j].y=ry3*per;
					mcList[j].scale=per;
					mcList[j].alpha=per;
					
					mcList[j].alpha=(mcList[j].alpha-0.6)*(10/6);
				}
				
				doPosition();
				depthSort();
			}

			function depthSort() {
				var i=0;
				var aTmp=[];
				
				for(i=0;i<aA.length;i++)
				{
					aTmp.push(aA[i]);
				}
				
				aTmp.sort
				(
					function (vItem1, vItem2)
					{
						if(vItem1.cz>vItem2.cz)
						{
							return -1;
						}
						else if(vItem1.cz<vItem2.cz)
						{
							return 1;
						}
						else
						{
							return 0;
						}
					}
				);
				
				for(i=0;i<aTmp.length;i++) {
					aTmp[i].style.zIndex=i;
				}
			}

			function positionAll()
			{
				var phi=0;
				var theta=0;
				var max=mcList.length;
				var i=0;
				
				var aTmp=[];
				var oFragment=document.createDocumentFragment();
				
				//随机排序
				for(i=0;i<aA.length;i++)
				{
					aTmp.push(aA[i]);
				}
				
				aTmp.sort
				(
					function ()
					{
						return Math.random()<0.5?1:-1;
					}
				);
				
				for(i=0;i<aTmp.length;i++)
				{
					oFragment.appendChild(aTmp[i]);
				}
				
				oDiv.appendChild(oFragment);
				
				for( var i=1; i<max+1; i++){
					if( distr )
					{
						phi = Math.acos(-1+(2*i-1)/max);
						theta = Math.sqrt(max*Math.PI)*phi;
					}
					else
					{
						phi = Math.random()*(Math.PI);
						theta = Math.random()*(2*Math.PI);
					}
					//坐标变换
					mcList[i-1].cx = radius * Math.cos(theta)*Math.sin(phi);
					mcList[i-1].cy = radius * Math.sin(theta)*Math.sin(phi);
					mcList[i-1].cz = radius * Math.cos(phi);
					
					aA[i-1].style.left=mcList[i-1].cx+oDiv.offsetWidth/2-mcList[i-1].offsetWidth/2+'px';
					aA[i-1].style.top=mcList[i-1].cy+oDiv.offsetHeight/2-mcList[i-1].offsetHeight/2+'px';
				}
			}

			function doPosition()
			{
				var l=oDiv.offsetWidth/2;
				var t=oDiv.offsetHeight/2;
				for(var i=0;i<mcList.length;i++)
				{
					aA[i].style.left=mcList[i].cx+l-mcList[i].offsetWidth/2+'px';
					aA[i].style.top=mcList[i].cy+t-mcList[i].offsetHeight/2+'px';
					
					const size = (aA[i].getAttribute('size') || 1) * 1;
					aA[i].style.fontSize=Math.ceil(12 * size * mcList[i].scale/2)+8+'px';
					
					aA[i].style.filter="alpha(opacity="+100*mcList[i].alpha+")";
					aA[i].style.opacity=mcList[i].alpha;
				}
			}

			function sineCosine( a, b, c) {
				sa = Math.sin(a * dtr);
				ca = Math.cos(a * dtr);
				sb = Math.sin(b * dtr);
				cb = Math.cos(b * dtr);
				sc = Math.sin(c * dtr);
				cc = Math.cos(c * dtr);
			}

		},
		gdp() {
			const _this = this;
			this.gdpChart = echarts.init(document.getElementById('gdp'));
			let option = {
				legend: {
					show: true,
					icon: 'roundRect',
					top: 20
				},
				grid: {
					left: '20%',
					tooltip: {
						show: true,
					}
				},
				xAxis: {
					type: 'category',
					data: [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019],
					axisLabel: {
						rotate: -45,
						fontSize: 12
					}
				},
				yAxis: {
					type: 'value'
				},
				series: [{
					data: [412119.3, 487940.2, 538580.0, 592963.2, 643563.1, 688858.2, 746395.1, 832035.9, 919281.1, 990865.1],
					type: 'line',
					name: '国内生产总值(亿元)'
				}],
				animation: true,
			};

			this.gdpChart.setOption(option);
			setInterval(function() {
				_this.gdpChart.clear();
				_this.gdpChart.setOption(option);
			}, 5000);
		},
		zpsr() {
			const _this = this;
			this.zpsrChart = echarts.init(document.getElementById('zpsr'));
			let option = {
				legend: {
					show: true,
					icon: 'roundRect',
					top: 20
				},
				grid: {
					left: '20%',
					tooltip: {
						show: true,
					}
				},
				xAxis: {
					type: 'category',
					data: [2013, 2014, 2015, 2016, 2017, 2018, 2019],
					axisLabel: {
						rotate: -45,
						fontSize: 12
					}
				},
				yAxis: {
					type: 'value'
				},
				series: [{
					data: [18311, 20167, 21966, 23821, 25974, 28228, 30733],
					type: 'line',
					name: '居民人均可支配收入（元）'
				}],
				animation: true,
			};

			this.zpsrChart.setOption(option);
			setInterval(function() {
				_this.zpsrChart.clear();
				_this.zpsrChart.setOption(option);
			}, 6000);
		},
		pie() {
			this.pieChart = echarts.init(document.getElementById('pie'));
			let option = {
				title: {
						text: '2019年三次产业构成增加值(亿元)',
						left: 'center',
						top: 20,
						textStyle: {
								color: '#ccc'
						}
				},
				tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} ({d}%)'
				},
				visualMap: {
						show: false,
						min: 1,
						max: 1000000,
						inRange: {
								colorLightness: [0, 1]
						}
				},
				series: [
						{
								name: '增加值',
								type: 'pie',
								radius: '55%',
								center: ['50%', '50%'],
								data: [
									{value: 70466, name: '第一产业'},
									{value: 386165, name: '第二产业'},
									{value: 534233, name: '第三产业'},
								].sort(function (a, b) { return a.value - b.value; }),
								roseType: 'radius',
								label: {
										color: 'rgba(255, 255, 255, 0.3)'
								},
								labelLine: {
										lineStyle: {
												color: 'rgba(255, 255, 255, 0.3)'
										},
										smooth: 0.2,
										length: 10,
										length2: 20
								},
								itemStyle: {
										color: '#c23531',
										shadowBlur: 200,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
								},

								animationType: 'scale',
								animationEasing: 'elasticOut',
								animationDelay: function (idx) {
										return Math.random() * 200;
								}
						}
				]
			};

			this.pieChart.setOption(option);
		},
		onWorld() {
			this.menu = 2;
			lasta = 1;
			lastb = 1;
		}
  }
}
</script>

<style lang="less" scoped>
.body {
	background: url('../assets/img/bg.jpg') center top;
	background-size: 100%;
}
.head {
	width: 100vw;
	display: flex;
	background: url('../assets/img/head.jpg') center top;
	background-size: 100%;
	height: 71.866vw;
	align-items: flex-end;
	overflow: hidden;
	.menu {
		width: 100%;
		display: flex;
		justify-content: center;
		position: absolute;
		align-items: flex-end;
		img {
			width: 21.68vw;
			height: 11.82vw;
			display: table;
		}
		.hover {
			width: 35vw;
			height: 17.24vw;
		}
	}
	.menu-top {
		position: fixed;
		top: 0;
		z-index: 999;
		background: #fff7f5;
	}
}
.title {
	width: 90vw;
	margin: 3vw auto;
	font-family: 'ysbth';
	font-size: 6vw;
	border-left: 1vw solid #dd2b23;
	color: #dd2b23;
	padding-left: 3vw;
}
.map {
	min-height: 115vw;
	margin-top: -1px;
	padding-top: 6vw;
	#map {
		height: 80vw;
	}
	.map-content {
		width: 56.6vw;
		margin: 0 auto;
		background: white;
		color: black;
		font-size: 3.6vw;
		font-weight: bold;
		padding: 3vw 4vw;
		box-sizing: border-box;
		border: 1px solid #4b4b4b;
		line-height: 1.4em;
		.map-title {
			border-bottom: 1px solid #8c8c8c;
			padding-bottom: 2vw;
		}
	}
	.map-btn {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 2vw;
		.map-prov {
			display: flex;
			font-size: 3.2vw;
			align-items: center;
			color: #dd2b23;
			font-weight: normal;
			img {
				width: 4.2vw;
				height: 4.2vw;
				margin-right: 1vw;
			}
		}
		.map-skip {
			width: 24.8vw;
			height: 6.8vw;
		}
	}
}

.world {
	background: url('../assets/img/bg.jpg') center top;
	margin-top: -1px;
}
#tagbox{
	position: relative;
	width: 100vw;
	height: 100vw;
	margin-left: -5vw;
	a {
		position:absolute;
		padding:3px 6px;
		color: black;
		TOP: 0px;
		font-weight: bold;
		text-decoration: none;
		left:0px;
	}
	a:hover {
		border:#eee 1px solid;
	}
}
.data {
	width: 100vw;
	#gdp {
		width: 100vw;
		height: 70vw;
	}
	#zpsr {
		width: 100vw;
		height: 70vw;
	}
	#pie {
		width: 100vw;
		height: 100vw;
	}
	.data-list {
		width: 80vw;
		margin: 0 auto 5vw auto;
		font-size: 3.2vw;
		color: #2f2f2f;
		.data-item {
			border-bottom: 1px solid #767271;
			margin-top: 2vw;
			.data-item-name {
				font-size: 6vw;
				font-family: 'ysbth';
				span {
					color: #dd2b23;
					font-size: 9vw;
				}
			}
			p {
				padding: 1vw 0 3vw 0;
				line-height: 1.5em;
			}
			&:last-child {
				border-bottom: 0;
			}
		}
	}
}
.news {
	.news-item {
		display: flex;
		padding: 3vw;
		box-sizing: border-box;
		justify-content: space-between;
		text-decoration: none;
		img {
			width: 28vw;
			height: 21vw;
			flex-shrink: 0;
			margin-right: 3vw;
			border-radius: .5vw;
		}
		.news-title {
			width: 67vw;
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			.news-name {
				font-size: 4.0vw;
				font-weight: bold;
				color: black;
				line-height: 1.5em;
			}
			.news-source {
				color: #747474;
				font-size: 3vw;
			}
		}
	}
}
</style>